import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { portfolioData } from "../mock";

export const Portfolio = () => {
  const [projects] = useState(portfolioData);
  const loading = false;

  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-slate-900 mb-4">
            Our Portfolio
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Pioneering ventures that are reshaping industries and driving Web3
            adoption across Africa
          </p>
        </div>

        {/* Portfolio Grid */}
        {loading ? (
          <div className="text-center py-12">
            <p className="text-slate-600">Loading projects...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            {projects.map((project) => (
              <Link
                key={project.id}
                to={`/portfolio/${project.slug}`}
                className="group"
              >
                <div className="bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-2xl transition-all duration-300">
                  <div className="relative h-72 overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute top-4 right-4">
                      <span
                        className={`px-4 py-1 rounded-full text-sm font-semibold backdrop-blur-sm ${
                          project.status === "Live"
                            ? "bg-green-500/90 text-white"
                            : project.status === "Development"
                            ? "bg-blue-500/90 text-white"
                            : "bg-amber-500/90 text-white"
                        }`}
                      >
                        {project.status}
                      </span>
                    </div>
                  </div>
                  <div className="p-8">
                    <p className="text-sm text-orange-600 font-semibold mb-2 uppercase tracking-wide">
                      {project.category}
                    </p>
                    <h3 className="text-3xl font-bold text-slate-900 mb-4">
                      {project.name}
                    </h3>
                    <p className="text-slate-600 mb-6 leading-relaxed">
                      {project.description}
                    </p>
                    <div className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors">
                      Learn More <ExternalLink className="ml-2" size={18} />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
